export default class SettleReceivableApi {
    // 导出DN单
    postExportDN(params) {
        const url = `finance/receivableSettlement/exportDn/${params.id}`;
        return this.GETFILE(url, params);
    }
}
